import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './constants'
import { scrollTo } from '@/helpers/functions'
import { TYPE_RADIO, TYPE_CHECKBOX } from '@/modules/question/preview-question/_store/constants'

export default {
  computed: {
    ...mapState(STORE_KEY, ['questionList']),
   
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetListQuestions', 'acSetQuestionIndexWorking', 'acSetQuestionDetail']),

    addNewQuestion () {
      let questions = this.questionList
      const questionLength = questions.length
      const orderNo = questions.length ? questions[questionLength - 1].orderNo + 1 : 0
      const questionNew = {questionId: 0, isNew: true, title: `Câu ${questionLength + 1}`, content: '', answers: [], guideContent: '',suggestion: '', answerDetail: '', layoutId: 1, type: TYPE_RADIO, orderNo}
      questions.push(questionNew)
      this.acSetListQuestions(questions)
      this.handleWorkingQuestionDetail(questionNew, questionLength)
    },

    handleWorkingQuestionDetail (data, index) {
      this.resetQuestionWorking()
      if (data.type === TYPE_CHECKBOX) {
        data['multiCorrectCheckbox'] = []
      }
      data.answers && data.answers.map((ans, index) => {
        if(ans.correct ) {
          ans['answerContent'] = ans.orderNo
          data.type === TYPE_CHECKBOX && data.multiCorrectCheckbox.push(ans.orderNo)
        }
      })
      this.acSetQuestionDetail(data)
      setTimeout(() => {
        this.acSetQuestionIndexWorking(index)
        this.setScrollToCat(index)
      }, 100)
    },

    resetQuestionWorking () {
      this.acSetQuestionDetail({})
      this.acSetQuestionIndexWorking(-1)
    },

    setScrollToCat(index) {
      let elem = document.getElementById(`question_sidebar_${index}`);
      if(elem) {
        let topPos = elem.offsetTop;
        scrollTo(document.getElementById('sidebar__questions'), topPos, 600);
      }
    },
  }
}